module.exports = __webpack_public_path__ + "assets/youtube-dark.7383403f.svg";